import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
};

const userInfoSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    userData: (state, action) => {
      state.data = action.payload;
    },
  },
});
export default userInfoSlice.reducer;
export const { userData } = userInfoSlice.actions;
